module.exports = __webpack_public_path__ + "static/img/label-05.1dc0349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/label-05.png
// module id = T2FJ
// module chunks = 150